import React from "react";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";

const Card = (props) => {
  const review = props.review;

  return (
    <div className="policy-card impact-testimonial-card">
      <div className="impact-testimonial-header">
        <p className="impact-testimonial-name">{review.name}</p>
        <p className="impact-testimonial-meta">{review.job}</p>
      </div>

      <div className="impact-testimonial-quote" aria-hidden="true">
        <FaQuoteLeft />
      </div>

      <p className="impact-testimonial-text">{review.text}</p>

      <div className="impact-testimonial-quote" aria-hidden="true">
        <FaQuoteRight />
      </div>
    </div>
  );
};

export default Card;
